const kleberKey = $('#checkout-main').length
	? $('#checkout-main').data('kleber')
	: $('#address-main').data('kleber');

const replaceAddress = (item, selector = '') => {
	var target = selector.length > 0 ? '[name*="' + selector + '"]' : '';

	$('#address1, input[name$=_address1]' + target).val(item.AddressLine);
	$('#city, input[name$=_city]' + target).val(item.Locality);
	$('#zipCode, input[name$=_postalCode]' + target).val(item.Postcode);
	$('#streetNumber, input[name$=_streetNumber]' + target).val(item.StreetNumber1);
	$('#streetName, input[name$=_streetName]' + target).val(item.StreetName + ' ' + item.StreetType);
	$('#state, select[name$=_stateCode]' + target + ', input[name$=_stateCode]' + target).val(item.State);
};

const handleAddressAutocomplete = (request, response) => {
	if (request.term.replace(/[^A-Z]/gi, '').length > 2) {
		$.ajax({
			url: 'https://kleber.datatoolscloud.net.au/KleberWebService/DtKleberService.svc/ProcessQueryStringRequest',
			dataType: 'jsonp',
			type: 'GET',
			contentType: 'application/json; charset=utf-8',
			data: {
				Method: 'DataTools.Capture.Address.Predictive.AuPaf.SearchAddress',
				ResultLimit: '5',
				AddressLine: request.term,
				RequestKey: kleberKey,
				OutputFormat: 'json',
			},


			success: function(data) {
				response(
					$.map(data.DtResponse.Result, function(item) {
						const label = `${item.AddressLine}, ${item.Locality}, ${item.State}, ${item.Postcode}`;
						return {
							label: label,
							value: label,
							Output: item,
						};
					}),
				);
			},
		});
	}
};

const handleSelectAddress = (event, ui) => {
	event.preventDefault();

	if (ui.item && ui.item.Output) {
		 $.get({
		 	url: "https://kleber.datatoolscloud.net.au/KleberWebService/DtKleberService.svc/ProcessQueryStringRequest",
		 	dataType: "jsonp",
		 	contentType: "application/json; charset=utf-8",
		 	data: {
		 		Method: "DataTools.Capture.Address.Predictive.AuPaf.RetrieveAddress",
		 		RecordId: ui.item.Output.RecordId,
		 		RequestKey: kleberKey,
		 		OutputFormat: "json"
		 	},
			 success: function (data) {
				$.map(data.DtResponse.Result, function (item) {
					if ($(event.target).hasClass('billingAddressOne')) {
						replaceAddress(item, 'billing');
					} else if ($(event.target).hasClass('shippingAddressOne') && !$('.billing-form').hasClass('collapsed')) {
						replaceAddress(item, 'shipping');
					} else {
						replaceAddress(item);
					}
				});
			}
		});
	}
};

module.exports = {
	init: function () {
		$('#address1, input[name$=_address1]').autocomplete({
			source: handleAddressAutocomplete,
			select: handleSelectAddress,
			minLength: 3,
		});
	}
};
